import React, { useState } from "react";

import { Building2, AlertCircle, Loader2, Check } from "lucide-react";

import { authFetch } from '../../../../../HttpClient';

import { dialog } from "../../../../../components/ui/Dialog";
const ModifModifSct = ({ item, onClose, fetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    activeForme: item.activeForme || false,
    nouvelleFormeSociale: item.nouvelleFormeSociale || "",
    commentaireForme: item.commentaireForme || "",
    activeSiege: item.activeSiege || false,
    adresseNouveauSiege: item.adresseNouveauSiege || "",
    commentaireSiege: item.commentaireSiege || "",
    activeDateCloture: item.activeDateCloture || false,
    nouvelleDateCloture: item.nouvelleDateCloture || "",
    commentaireDate: item.commentaireDate || "",
    activeDenomination: item.activeDenomination || false,
    nouvelleDenomination: item.nouvelleDenomination || "",
    commentaireDenomination: item.commentaireDenomination || "",
    activeObjetSocial: item.activeObjetSocial || false,
    modificationObjet: item.modificationObjet || "",
    nouvellesActivites: item.nouvellesActivites || "",
    commentaireObjet: item.commentaireObjet || "",
    activeCapital: item.activeCapital || false,
    nouveauCapital: item.nouveauCapital || "",
    commentaireCapital: item.commentaireCapital || "",
    activeDirigeant: item.activeDirigeant || false,
    typeModificationDirigeant: item.typeModificationDirigeant || "",
    commentaireDirigeant: item.commentaireDirigeant || "",
    nature: item.nature || "Juridique",
    dueDate: item.dueDate ? item.dueDate.split("T")[0] : "",
    priority: item.priority || "classique",
    status: item.status || "En attente",
    coefficient: item.coefficient || "",
    todoCommentaire: item.commentaire || "",
    //
  });

  console.log("Form Data:", formData);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    try {
      const modifPayload = {
        nouvelleFormeSociale: formData.activeForme
          ? formData.nouvelleFormeSociale
          : null,
        commentaireForme: formData.activeForme
          ? formData.commentaireForme
          : null,
        adresseNouveauSiege: formData.activeSiege
          ? formData.adresseNouveauSiege
          : null,
        commentaireSiege: formData.activeSiege
          ? formData.commentaireSiege
          : null,
        nouvelleDateCloture: formData.activeDateCloture
          ? new Date(formData.nouvelleDateCloture).toISOString()
          : null,
        commentaireDate: formData.activeDateCloture
          ? formData.commentaireDate
          : null,
        nouvelleDenomination: formData.activeDenomination
          ? formData.nouvelleDenomination
          : null,
        commentaireDenomination: formData.activeDenomination
          ? formData.commentaireDenomination
          : null,
        modificationObjet: formData.activeObjetSocial
          ? formData.modificationObjet
          : null,
        nouvellesActivites: formData.activeObjetSocial
          ? formData.nouvellesActivites
          : null,
        commentaireObjet: formData.activeObjetSocial
          ? formData.commentaireObjet
          : null,
        nouveauCapital: formData.activeCapital ? formData.nouveauCapital : null,
        commentaireCapital: formData.activeCapital
          ? formData.commentaireCapital
          : null,
        typeModificationDirigeant: formData.activeDirigeant
          ? formData.typeModificationDirigeant
          : null,
        commentaireDirigeant: formData.activeDirigeant
          ? formData.commentaireDirigeant
          : null,
        dueDate: formData.dueDate,
        priority: formData.priority,
        status: formData.status,
        coefficient: formData.coefficient,
        commentaire: formData.todoCommentaire,
      };
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/modifsct/${item.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(modifPayload),
        }
      );

      if (!res.ok) throw new Error("Erreur lors de la modification");
    } catch (error) {
      console.error(error);
      dialog.alert("Erreur lors de la modification");
    } finally {
      onClose();
    }
    fetchData();
  };

  return (
    <div className="w-full px-8">
      <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Modification de Société
        </h3>
      </div>
      <form onSubmit={handleSubmit}>
        <br />
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div className="space-y-4">
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeForme"
                  checked={formData.activeForme}
                  onChange={handleChange}
                />{" "}
                Modifier Forme Sociale
              </label>
              {formData.activeForme && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.nouvelleFormeSociale
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
                    type="text"
                    name="nouvelleFormeSociale"
                    placeholder="Nouvelle Forme Sociale"
                    value={formData.nouvelleFormeSociale}
                    onChange={handleChange}
                  />

                  <input
                    className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.commentaireForme
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
                    type="text"
                    name="commentaireForme"
                    placeholder="Commentaire"
                    value={formData.commentaireForme}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Siege */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeSiege"
                  checked={formData.activeSiege}
                  onChange={handleChange}
                />{" "}
                Modifier Siege
              </label>
              {formData.activeSiege && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.adresseNouveauSiege
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="adresseNouveauSiege"
                    placeholder="Adresse Nouveau Siege"
                    value={formData.adresseNouveauSiege}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireSiege
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireSiege"
                    placeholder="Commentaire"
                    value={formData.commentaireSiege}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Date de clôture */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDateCloture"
                  checked={formData.activeDateCloture}
                  onChange={handleChange}
                />{" "}
                Modifier Date de Clôture
              </label>
              {formData.activeDateCloture && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvelleDateCloture
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="date"
                    name="nouvelleDateCloture"
                    placeholder="Nouvelle Date de Clôture"
                    value={formData.nouvelleDateCloture}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDate
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDate"
                    placeholder="Commentaire"
                    value={formData.commentaireDate}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Dénomination */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDenomination"
                  checked={formData.activeDenomination}
                  onChange={handleChange}
                />{" "}
                Modifier Dénomination
              </label>
              {formData.activeDenomination && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvelleDenomination
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouvelleDenomination"
                    placeholder="Nouvelle Dénomination"
                    value={formData.nouvelleDenomination}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDenomination
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDenomination"
                    placeholder="Commentaire"
                    value={formData.commentaireDenomination}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Objet Social */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeObjetSocial"
                  checked={formData.activeObjetSocial}
                  onChange={handleChange}
                />{" "}
                Modifier Objet Social
              </label>
              {formData.activeObjetSocial && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.modificationObjet
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="modificationObjet"
                    placeholder="Modification Objet"
                    value={formData.modificationObjet}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouvellesActivites
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouvellesActivites"
                    placeholder="Nouvelles Activités"
                    value={formData.nouvellesActivites}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireObjet
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireObjet"
                    placeholder="Commentaire"
                    value={formData.commentaireObjet}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Capital */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeCapital"
                  checked={formData.activeCapital}
                  onChange={handleChange}
                />{" "}
                Modifier Capital
              </label>
              {formData.activeCapital && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.nouveauCapital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="nouveauCapital"
                    placeholder="Nouveau Capital"
                    value={formData.nouveauCapital}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireCapital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireCapital"
                    placeholder="Commentaire"
                    value={formData.commentaireCapital}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Dirigeant */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name="activeDirigeant"
                  checked={formData.activeDirigeant}
                  onChange={handleChange}
                />{" "}
                Modifier Dirigeant
              </label>
              {formData.activeDirigeant && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.typeModificationDirigeant
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="typeModificationDirigeant"
                    placeholder="Type de Modification Dirigeant"
                    value={formData.typeModificationDirigeant}
                    onChange={handleChange}
                  />

                  <input
                    className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.commentaireDirigeant
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
                    type="text"
                    name="commentaireDirigeant"
                    placeholder="Commentaire"
                    value={formData.commentaireDirigeant}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.dueDate
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.priority
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.status
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.coefficient
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
        </div>
        <div className="mt-4">
          <label className="text-sm font-medium text-slate-700 mb-1 block">
            Commentaire :
          </label>
          <textarea
            name="todoCommentaire"
            rows={4}
            value={formData.todoCommentaire}
            onChange={handleChange}
            placeholder="Précisions..."
            className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
          />
        </div>
        <br />
        <div className="sticky bottom-0 bg-white border-t mt-4 px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onClose}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`
w-1/2
h-11
${
  isSubmitting
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#9B1B5D] hover:bg-[#7A1548]"
}
text-white
text-base
font-medium
rounded-md
shadow-lg shadow-[#9B1B5D]/20
transition-colors
flex items-center justify-center
gap-2
`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Modifiaction en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Modifier la mission
              </>
            )}
          </button>
        </div>
        <br />
      </form>
    </div>
  );
};

export default ModifModifSct;
